import { getCurrentSubdomain } from "@/common/functions";
import FooterLinks from "@/components/FooterLinks/FooterLinks.vue";

export default {
    name: "MainNavigation",
    props: ["open", "menu"],
    components: {
        FooterLinks
    },
    methods: {
        menuItemClickHandler(event, item) {
            item.expanded = !item.expanded;
        },
        isCurrent(item) {
            let currentSubdomain = getCurrentSubdomain();
            if (currentSubdomain === `abbreviations`) {
                currentSubdomain = `reference`;
            }
            return item.subdomain === currentSubdomain;
        },
        onOutsideClick() {
            this.$root.$emit("BurgerButton");
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/MainNavigation/MainNavigation.js